var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512.025 269.925 510.898 283.827 508.632 297.566C497.946 362.785 462.451 421.345 409.576 460.992C356.7 500.639 290.54 518.301 224.939 510.283C159.339 502.264 99.3808 469.186 57.6116 417.97C15.8423 366.754 -4.50164 301.369 0.836526 235.496C6.17469 169.623 36.7813 108.367 86.2522 64.5451C135.723 20.723 200.225 -2.26909 266.26 0.379721C332.296 3.02853 394.749 31.113 440.551 78.7566C486.353 126.4 511.955 189.911 512 256Z",
    fill: "url(#paint0_linear_6_77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.632 297.566C499.931 350.43 474.864 399.231 436.963 437.096C399.062 474.961 350.236 499.981 297.364 508.632L150.366 361.634C126.046 211.267 165.053 147.2 165.053 147.2H358.232L508.632 297.566Z",
    fill: "url(#paint1_linear_6_77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.739 128H204.261C184.044 128.027 164.662 136.07 150.366 150.366C136.07 164.662 128.027 184.044 128 204.261V307.739C128.027 327.956 136.07 347.338 150.366 361.634C164.662 375.93 184.044 383.973 204.261 384H307.739C327.959 383.982 347.346 375.942 361.644 361.644C375.942 347.346 383.982 327.959 384 307.739V204.261C383.973 184.044 375.93 164.662 361.634 150.366C347.338 136.07 327.956 128.027 307.739 128ZM358.265 307.739C358.265 321.139 352.942 333.991 343.466 343.466C333.991 352.942 321.139 358.265 307.739 358.265H204.261C190.861 358.265 178.009 352.942 168.534 343.466C159.058 333.991 153.735 321.139 153.735 307.739V204.261C153.735 190.861 159.058 178.009 168.534 168.534C178.009 159.058 190.861 153.735 204.261 153.735H307.739C321.139 153.735 333.991 159.058 343.466 168.534C352.942 178.009 358.265 190.861 358.265 204.261V307.739Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 189.811C242.899 189.804 230.091 193.683 219.196 200.957C208.3 208.231 199.807 218.574 194.791 230.676C189.774 242.778 188.46 256.096 191.014 268.945C193.568 281.794 199.876 293.597 209.14 302.861C218.403 312.124 230.206 318.432 243.055 320.986C255.904 323.54 269.222 322.226 281.324 317.209C293.426 312.193 303.769 303.7 311.043 292.804C318.317 281.909 322.196 269.101 322.189 256C322.163 238.454 315.181 221.634 302.774 209.227C290.366 196.819 273.546 189.837 256 189.811ZM256 296.421C248.006 296.421 240.191 294.05 233.543 289.609C226.896 285.167 221.715 278.854 218.656 271.468C215.596 264.083 214.796 255.955 216.356 248.114C217.915 240.273 221.765 233.071 227.418 227.418C233.071 221.765 240.273 217.915 248.114 216.356C255.955 214.796 264.083 215.596 271.468 218.656C278.854 221.715 285.167 226.896 289.609 233.543C294.05 240.191 296.421 248.006 296.421 256C296.421 266.72 292.162 277.002 284.582 284.582C277.002 292.162 266.72 296.421 256 296.421Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322.594 206.181C331.635 206.181 338.964 198.852 338.964 189.81C338.964 180.769 331.635 173.44 322.594 173.44C313.552 173.44 306.223 180.769 306.223 189.81C306.223 198.852 313.552 206.181 322.594 206.181Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_77",
    x1: 256,
    y1: 509.642,
    x2: 256,
    y2: 34.6946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_77",
    x1: 156.968,
    y1: 157.069,
    x2: 427.655,
    y2: 427.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99155B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#99155B",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99165A",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#99175A",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#991859",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.7a7fe2311215d45a2257aef91a9fbbdc.svg";
export { ForwardRef as ReactComponent };